export const ADD_SUPPORTUSERS_INIT_ACTION = "ADD_SUPPORTUSERS_INIT_ACTION";
export const ADD_SUPPORTUSERS_SUCCESS_ACTION =
  ADD_SUPPORTUSERS_INIT_ACTION + "_SUCCESS";
export const ADD_SUPPORTUSERS_FAIL_ACTION =
  ADD_SUPPORTUSERS_INIT_ACTION + "_ERROR";

export const FETCH_SUPPORTUSERSLIST_INIT_ACTION =
  "FETCH_SUPPORTUSERSLIST_INIT_ACTION";
export const FETCH_SUPPORTUSERSLIST_SUCCESS_ACTION =
  FETCH_SUPPORTUSERSLIST_INIT_ACTION + "_SUCCESS";
export const FETCH_SUPPORTUSERSLIST_FAIL_ACTION =
  FETCH_SUPPORTUSERSLIST_INIT_ACTION + "_ERROR";

export const DELETE_SUPPORTUSERS_INIT_ACTION =
  "DELETE_SUPPORTUSERS_INIT_ACTION";
export const DELETE_SUPPORTUSERS_SUCCESS_ACTION =
  DELETE_SUPPORTUSERS_INIT_ACTION + "_SUCCESS";
export const DELETE_SUPPORTUSERS_FAIL_ACTION =
  DELETE_SUPPORTUSERS_INIT_ACTION + "_ERROR";

export const UPDATE_SUPPORTUSERS_INIT_ACTION = "UPDATE_SUPPORTUSERS_INI_ACTION";
export const UPDATE_SUPPORTUSERS_SUCCESS_ACTION =
  UPDATE_SUPPORTUSERS_INIT_ACTION + "_SUCCESS";
export const UPDATE_SUPPORTUSERS_FAIL_ACTION =
  UPDATE_SUPPORTUSERS_INIT_ACTION + "_ERROR";

export const FETCH_SUPPORTUSERS_SEARCH_INIT_ACTION =
  "FETCH_SUPPORTUSERS_SEARCH_INIT_ACTION";
export const FETCH_SUPPORTUSERS_SEARCH_SUCCESS_ACTION =
  FETCH_SUPPORTUSERS_SEARCH_INIT_ACTION + "_SUCCESS";
export const FETCH_SUPPORTUSERS_SEARCH_FAIL_ACTION =
  FETCH_SUPPORTUSERS_SEARCH_INIT_ACTION + "_ERROR";

export function addSupportUsers(value) {
  // console.log("ADD romy");
  return {
    type: ADD_SUPPORTUSERS_INIT_ACTION,
    value: value
  };
}

export function supportUsersViewList() {
  // console.log("romy");
  return {
    type: FETCH_SUPPORTUSERSLIST_INIT_ACTION
  };
}

export function deleteSupportUsers(items) {
  return {
    type: DELETE_SUPPORTUSERS_INIT_ACTION,
    items: items
  };
}
export function editSupportUsers(value) {
  return {
    type: UPDATE_SUPPORTUSERS_INIT_ACTION,
    value: value
  };
}
export function supportUsersSearch(value) {
  return {
    type: FETCH_SUPPORTUSERS_SEARCH_INIT_ACTION,
    value: value
  };
}
export function supportUsersSlectedPage(value) {
  return {
    type: FETCH_SUPPORTUSERSLIST_INIT_ACTION,
    value: value
  };
}
